export default __webpack_public_path__ + "static/media/Shemite Wayfarer Armbands.e3fe7630.jpg";